import { ReactNode, useEffect } from 'react';

import './Overlay.scss';

interface OverlayProps {
  children?: ReactNode;
}

export default function Overlay({ children }: OverlayProps) {
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, []);
  return <div className="overlay">{children}</div>;
}
